import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_GREY_7 } from "shared/theme/colors";
import { flexCenter } from "shared/theme/mixins";

export const StyledChip = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor",
})<{
  bgColor?: string;
  borderColor?: string;
}>`
  ${flexCenter()};
  background-color: ${({ bgColor }) => bgColor || COLOR_GREY_7};
  min-width: 50px;
  height: 24px;
  padding: 0 0.5rem;
  border: 1px solid ${({ borderColor }) => borderColor || COLOR_GREY_7};
  border-radius: 8px;
  width: fit-content;
`;
